import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function StripeCardPayment({ id, totalAmount, month }) {
  return (
    <Col className="stripe-card-payment-element">
      <Row className="justify-content-center align-items-center">
        <Col lg={9}>
          <h5>${totalAmount.toLocaleString()}</h5>
        </Col>
        <Col lg={3}>
          <h6>{month}</h6>
        </Col>
      </Row>
    </Col>
  );
}

export default StripeCardPayment;
